@if (text) {
  <small @errorMessageAnimation [id]="errorId" role="alert" class="bb-input-validation-message">
    {{ text }}
  </small>
}
